export enum IncomingOrdersOverviewTableColumn {
  ProductionOrderId = "productionOrderId",
  TotalQuantity = "totalQuantity",
  TotalCost = "totalCost",
  WarehouseName = "warehouseName",
  VariantIds = "variantIds",
  ExpectedDepartureDate = "expectedDepartureDate",
  ExpectedArrivalDate = "expectedArrivalDate",
  Status = "status",
  ShipmentMethod = "shipmentMethod",
  Collection = "collection",
  Vendor = "vendor",
  Actions = "actions",
}

// ERP-reported, unlike the supply plan ETD (ETA minus shipping lead time) — don't share its tooltip
export const ERP_ETD_TOOLTIP =
  "Estimated time of departure: when the goods leave the vendor (ex-factory). Comes from your ERP. Empty when your ERP doesn't send it."
